<template>
  <div id="app">
    <app-navigation-bar></app-navigation-bar>
    <app-whatsapp></app-whatsapp>
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
    <app-footer></app-footer>
  </div>
</template>

<script>
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import Whatsapp from "./components/Whatsapp";

export default {
  name: "App",
  components: {
    "app-navigation-bar": NavigationBar,
    "app-footer": Footer,
    "app-whatsapp": Whatsapp,
  },
  data: function() {
    return {
      show: true,
    };
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

* {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  font-family: "Poppins";

  /*background-color: black;*/
  /*border: 1px solid red;*/
}
.justify-text {
  text-align: justify;
  text-justify: inter-word;
}
.center-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

@media screen and (max-width: 500px){
    
    .center-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
}
}
</style>
